import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterModule} from "@angular/router";
import {BreadcrumbModel} from "../../../../domain/models/breadcrumb.model";
import {NgForOf, NgIf} from "@angular/common";
import {BreadcrumbService} from "../../../../domain/services/breadcrumb/breadcrumb.service";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [
    RouterModule,
    NgIf,
    NgForOf,
    MatIcon
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css'
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs: BreadcrumbModel[] = [];

  constructor(private readonly breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe((newBreadcrumbs) => {
      this.breadcrumbs = newBreadcrumbs;
    });
  }
}
